import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function BugPrint(body, name,month,year) {
    let bList = []

    body.forEach(element => {
        const b = [
            `${element.id}`,
            `${element.mode.trim()}`,
            `${element.content.trim()}`
             ]
        bList = [...bList, b]

    })
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: "a4",
    });
    const heading = ['Folio', 'Mode', 'Details'];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Profit & Loss Report", 270, 40)
    doc.text(`Month:${month}`, 20, 55)
    doc.text(`Year:${year}`, 270, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 8, cellWidth: "auto"},
            showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),
            columnStyles: {
                0: {halign: "Left"},
                1: {halign: "Left"},
                2: {halign: "Left"},

            },
        }
    )
    doc.save(`BugReport-${year}-${month}.pdf`);
}



